import {
  ClickAwayListener, // メニュー項目内でアイコンを表示するためのコンポーネント
  Divider, // クリックがコンポーネント外で発生した場合に通知するリスナー
  ListItemIcon, // メニューリスト: 複数のメニュー項目を内包
  MenuItem, // 紙のような背景のコンテナ
  MenuList, // ポッパーコンポーネント: 任意の要素に対してポップアップを表示
  Paper,
  Popper, // ポッパーコンポーネント: 任意の要素に対してポップアップを表示
} from '@mui/material';

import PostAdd from '@mui/icons-material/PostAdd';

/**
 * OthersIconDropdownProps コンポーネントに渡すプロパティの型定義
 *
 * @interface OthersIconDropdownProps
 * @property {boolean} open - ドロップダウンが表示されるかどうかの真偽値
 * @property {(HTMLElement | null)} anchorInfo - ポップアップの表示位置を決定するアンカー要素。null の場合、表示位置は保証されません。
 * @property {(() => void) | undefined} [onClose] - ドロップダウンが閉じられる際に呼び出されるコールバック関数
 * @property {(itemName: string) => void} onSelected - メニュー項目が選択された際に、選択された項目名を引数として呼び出されるコールバック関数
 */
interface OthersIconDropdownProps {
  open: boolean;
  anchorInfo: HTMLElement | null;
  onClose?: () => void;
  onSelected: (itemName: string) => void;
}


/**
 * OthersIconDropdown コンポーネント
 *
 * 指定されたアンカー要素の下にドロップダウンメニューを表示する React コンポーネントです。
 * Material-UI の Popper コンポーネントを利用し、メニュー項目を表示します。
 * ClickAwayListener を使用して、メニュー外のクリックイベントを検出し、ドロップダウン外でクリックが発生した際にはonCloseコールバックを実行します。
 * また、メニュー内のアイテムが選択された際には onSelected コールバックを呼び出します。
 *
 * @param {OthersIconDropdownProps} props - コンポーネントに渡すプロパティ
 * @returns {JSX.Element} 表示するドロップダウンメニューの JSX 要素
 */
export default function OthersIconDropdown({
  open,
  anchorInfo,
  onClose,
  onSelected,
}: OthersIconDropdownProps) {
  // 本ドロップダウンを閉じ操作が発生したときに実行します
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Popper
      open={open}
      anchorEl={anchorInfo}
      placement="bottom-start" // 基本はアイコンの左下に表示
      disablePortal={false}
      // popperOptions に strategy と modifiers をまとめて指定
      popperOptions={{
        modifiers: [
          // placementで指定した配置位置では本ドロップダウンが画面外に出る場合、Anchorに対するドロップダウンの表示位置を左右や上下にひっくり返します
          {
            name: 'flip',
            enabled: true,
            options: {
              rootBoundary: 'viewport', // 画面全体を境界とする
              padding: 8, // 見た目をよくするために画面全体を境界としつつ、8pixel分の余裕を持たせます
            },
          },
        ],
      }}
    >
      <Paper>
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList autoFocusItem={open}>
            <MenuItem
              disabled
              sx={{
                '&.Mui-disabled': {
                  color: 'black',
                  opacity: 1,
                },
              }}
            >
              kintone
            </MenuItem>
            <MenuItem
              id="kintone-record-register"
              onClick={() => {
                handleClose();
                onSelected('kintoneRecordRegister');
              }}>
              <ListItemIcon>
                <PostAdd fontSize="small" />
              </ListItemIcon>
              レコード登録
            </MenuItem>
            <Divider />
          </MenuList>
        </ClickAwayListener>
      </Paper>
    </Popper>
  );
};